import { FunctionComponent } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodeBranch } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import NodeMenu from './NodeMenu';
import styles from './BaseStepNode.module.scss';

const SplitNode: FunctionComponent<NodeProps> = ({ data, selected }) => {
    const d = data as {
        label: string;
        subtitle: string;
        condition?: string;
        onRemove?: () => void;
        onFlipSplit?: () => void;
    };

    return (
        <>
            <Handle
                type="target"
                position={Position.Top}
                style={{ opacity: 0, pointerEvents: 'none' }}
            />
            <div className={clsx(styles.node, { [styles.selected]: selected })}>
                <div className={styles.iconDiamond}>
                    <FontAwesomeIcon
                        icon={faCodeBranch}
                        className={styles.iconDiamondInner}
                    />
                </div>
                <div className={styles.content}>
                    <span className={styles.title}>{d.label}</span>
                    <span className={styles.subtitle}>{d.condition || d.subtitle}</span>
                </div>
                {d.onRemove && (
                    <NodeMenu
                        onDelete={d.onRemove}
                        onFlipSplit={d.onFlipSplit}
                    />
                )}
            </div>
            {/* Two source handles for yes/no branches */}
            <Handle
                id="yes"
                type="source"
                position={Position.Bottom}
                style={{ left: '30%', opacity: 0, pointerEvents: 'none' }}
            />
            <Handle
                id="no"
                type="source"
                position={Position.Bottom}
                style={{ left: '70%', opacity: 0, pointerEvents: 'none' }}
            />
        </>
    );
};

export default SplitNode;
